// 过滤地块方法
function filterLand(list, filterObj) {
  const { landGroupIdArray, landName } = filterObj;
  let temp = list;
  if (landGroupIdArray.length) {
    temp = temp.filter((item) =>
      landGroupIdArray.includes(item.coLandVO.landGroupId)
    );
  }
  if (landName) {
    temp = temp.filter((item) => item.coLandVO.landName.includes(landName));
  }
  return temp;
}

export default {
  namespaced: true,
  state: {
    showLandMode: "ListMode", // 地块显示模式
    landLoading: true, // 地块查询 loading
    insureId: null,
    landList: [], // 用于页面展示的数据
    // cropGroupSelectList: [],
    landGroupSelectList: [],
    filterLandCondition: null, // 过滤地块的条件
    isSearch: false,
  },
  getters: {
    // 页面展示的地块数据
    showLandList(state) {
      if (state.filterLandCondition == null) {
        return state.landList;
      } else {
        return filterLand(state.landList, state.filterLandCondition);
      }
    },
    // 已经选中的列表
    hadSelectedLandList(state) {
      return state.landList.filter((land) => land.select);
    },
    // 判断是否全选中地块
    isSelectAllLand(state, getters) {
      const flagTrueList = getters.showLandList.filter(
        (land) => land.coLandVO.shGisLandTypeId == 1 && land.insureFlag
      );
      if (flagTrueList.length) {
        const laList = flagTrueList.every((item) => item.select);
        return laList;
      } else {
        return false;
      }
    },
    // 用于渲染地图模式数据
    renderMapData(state, getters) {
      return getters.showLandList.map((item) => {
        const obj = item.coLandVO;
        obj.cropList = [item.coCropVO];
        obj.select = item.select;
        obj.disable = item.coLandVO.shGisLandTypeId !== 1 || !item.insureFlag;
        obj.insureFailList = item.insureFailList;
        return obj;
      });
    },
  },
  mutations: {
    // 重置投保页面的状态
    clearInsurePageStatus(state) {
      state.filterLandCondition = null;
      state.showLandMode = "ListMode";
      state.landList = [];
      state.landLoading = true;
    },
    // 保存保险id
    setInsureId(state, id) {
      state.insureId = id;
    },
    // 修改地块显示模式
    changeShowLandMode(state, mode) {
      state.showLandMode = mode;
    },
    // 过滤地块信息
    filterLandList(state, obj) {
      if (!obj) {
        state.filterLandCondition = null;
        return;
      }
      const { landGroupIdArray, landName } = obj;
      state.filterLandCondition = {
        landGroupIdArray,
        landName,
      };
      state.isSearch = true;
    },
    removeSearchState(state) {
      state.isSearch = false;
    },
    // 设置所有地块数据
    setLandList(state, data) {
      state.landList = data;
    },
    // 编组下拉选择器数据
    setLandGroupList(state, list) {
      state.landGroupSelectList = list;
    },
    // 改变选中状态
    changeSelectStatus(state, landId) {
      state.landList = state.landList.map((item) => {
        if (item.landId == landId) {
          item.select = !item.select;
        }
        return item;
      });
    },
    // 全选（始终在愿数据上修改，然后通过 getters 分发）
    selectAllLand(state, data) {
      const { selectStatus, showLandList } = data;
      const landIds = showLandList.map((item) => item.landId);
      const temp_list = state.landList;
      temp_list.forEach((land) => {
        if (
          land.coLandVO.shGisLandTypeId == 1 &&
          land.insureFlag &&
          landIds.includes(land.landId)
        ) {
          land.select = selectStatus;
        }
      });
      state.landList = temp_list;
    },
    // loading 状态
    changeLoadingStatus(state, status) {
      state.landLoading = status;
    },
  },
};
